import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../../../contexts/AuthContext';
import { useTenant } from '../../../contexts/TenantContext';
import Sidebar from '../../admin-dashboard/components/Sidebar';

/**
 * Manager V2 Live — Phase 2 stub (scraping required).
 * Route : /manager/live + /manager/v2/live.
 * Feature : pages.manager.live (OFF par défaut côté Generic).
 *
 * Le live temps réel dépend du pipeline de scraping (check-live-backstage côté
 * Black OS). NoiRock Phase 1 n'a pas cette infra → page affiche un placeholder.
 * Sera branché Phase 2 quand `pages.manager.live` aura une source de données.
 */
const ManagerV2Live = () => {
  const { t } = useTranslation();
  const { userProfile } = useAuth();
  const { tenantName } = useTenant();
  const [collapsed, setCollapsed] = useState(false);

  return (
    <div className="flex min-h-screen bg-background text-foreground">
      <Sidebar collapsed={collapsed} onToggle={() => setCollapsed((c) => !c)} userEmail={userProfile?.email} />
      <main className="flex-1 min-w-0 overflow-x-hidden">
        <header className="border-b border-border bg-card sticky top-0 z-10">
          <div className="px-4 md:px-6 py-4">
            <h1 className="text-xl md:text-2xl font-heading font-bold text-foreground">
              {t('liveV2.title', 'Live now')}
            </h1>
            <p className="text-xs text-muted-foreground mt-0.5">{tenantName}</p>
          </div>
        </header>
        <div className="p-4 md:p-6">
          <div className="rounded-2xl bg-card border border-border p-8 md:p-12 text-center">
            <div className="inline-flex items-center justify-center w-14 h-14 rounded-2xl bg-accent/10 mb-4">
              <span className="w-3 h-3 rounded-full bg-accent/70" />
            </div>
            <h2 className="text-lg font-heading font-semibold text-foreground">
              {t('liveV2.stubTitle', 'Real-time live monitoring')}
            </h2>
            <p className="text-sm text-muted-foreground mt-2 max-w-md mx-auto">
              {t(
                'liveV2.stubBody',
                'Live tracking depends on the scraping pipeline (Phase 2). This feature is enabled per tenant by the super admin once the data source is wired.'
              )}
            </p>
            <span className="inline-block mt-4 text-[10px] uppercase tracking-widest px-2 py-1 rounded-full bg-muted text-muted-foreground">
              Phase 2
            </span>
          </div>
        </div>
      </main>
    </div>
  );
};

export default ManagerV2Live;
